export function SyncIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M8.533 4.6a.5.5 0 000 .8l2.667 2A.5.5 0 0012 7V6a6 6 0 015.143 9.091 1 1 0 101.713 1.033A8 8 0 0012 4V3a.5.5 0 00-.799-.4l-2.667 2zM6.437 7.634a1 1 0 01.365 1.367A6 6 0 0012 18v-1.001a.5.5 0 01.8-.4l2.667 2a.5.5 0 010 .8l-2.667 2a.5.5 0 01-.8-.4v-1A8 8 0 015.07 8a1 1 0 011.367-.366z"
      ></path>
    </svg>
  );
}
